<template lang="pug">
  .component-tabbed-client-invoices
    ActionBar
      h2(slot="title") Invoices
      InvoiceListForm(v-if="expanded", slot="action", type="entity-filter", @filterInvoices="filterInvoices")
      InvoiceListForm(v-if="expanded", slot="action", type="type-filter", @filterInvoices="filterInvoices")
      i.fa.fa-2x(slot="action", :class="{'fa-eye-slash':expanded, 'fa-eye':!expanded}", @click="expanded = !expanded")

    .tabs-inner-content(v-show="expanded")
      .text-right
        router-link(:to="{name:'credit-note', params:{client_id: $route.params.id, wallet_id:wallet.id}}")
          span.button Emit manual credit note

    base-list(:component="component", :search="search", :dataLoader="dataLoader", :resultsPerPage="5", componentType="client-invoices")
</template>
<script type="text/babel">
    import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
    import InvoiceListForm from '../../structure/ui/filters/InvoiceListForm'
    import BaseList from '../../../pages/backoffice/BaseList'
    import HeaderColumns from '../../structure/ui/HeaderColumns'
    import ActionBar from '../../structure/ui/ActionBar'

    export default {
        name: 'TabbedClientInvoices',
        components: {
            ActionBar,
            HeaderColumns,
            BaseList,
            InvoiceListForm,
        },
        data() {
            return {
                component: require('src/components/backoffice/Invoice'),
                expanded: true,
                filterStatus: null,
                filterType: null,
            }
        },
        created() {

        },
        methods: {
            filterInvoices(body) {
                this.filterStatus = body.status
                this.filterType = body.type
            },
            dataLoader(callback, page, resultsPerPage) {
                KeplerBackofficeSdk.invoices.list(page, resultsPerPage, this.search).client((data) => {
                    callback(data)
                })
            },
        },
        computed: {
            search() {
                return {
                    client_id: this.$route.params.id,
                    wallet_id: this.wallet.id,
                    status: this.filterStatus,
                    type: this.filterType,
                }
            }
        },
        props: ['wallet'],
    }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-tabbed-client-invoices
    .component-invoice-list-filter-form
      select
        padding: 0
        background-position: right 0 center
        height: auto
</style>



// WEBPACK FOOTER //
// ClientInvoices.vue?f6f6d3a8